import { ErrorHandler, Injectable } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { LoadingOverlayService } from '../services/loading-overlay.service';
import { Router } from '@angular/router';

// @Injectable({
//   providedIn: 'root'
// })
// export class GlobalErrorHandler implements ErrorHandler {

//   constructor(
//     private toastr: NotificationService,
//     private loaderService: LoadingOverlayService,
//   ) {

//   }

//   handleError(error: any): void {
//     if (error.message) {
//       if (!error.message.includes('NG0100')) {
//         this.toastr.erro(error);
//         this.loaderService.hide();
//         console.log(error);
//       }
//     } else {
//       this.toastr.erro(error);
//       this.loaderService.hide();
//       console.log(error);
//     }
//   }

// }

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

  private erroContador = new Map<string, number>();
  private erroTimestamps: number[] = [];

  constructor(
    private toastr: NotificationService,
    private loaderService: LoadingOverlayService,
    private router: Router
  ) {}

  handleError(error: any): void {
    const message = this.extractMessage(error);
    this.loaderService.hide();

    if (message.includes('NG0100')) return;

    const agora = Date.now();
    const chaveErro = message.slice(0, 200);
    const critico = this.isErroCritico(message);

    if (critico) {
      this.erroTimestamps.push(agora);

      // Remove timestamps mais antigos que 1 segundo
      this.erroTimestamps = this.erroTimestamps.filter(t => agora - t < 1000);

      // Se aconteceram 20 ou mais erros críticos em 1s
      if (this.erroTimestamps.length >= 20) {
        this.redirecionarParaPaginaDeErro(message);
        return;
      }

      // Evita mostrar toast spamado para o mesmo erro
      const jaMostrouToast = this.erroContador.get(chaveErro);
      if (!jaMostrouToast || agora - jaMostrouToast > 1000) {
        this.toastr.erro(message);
        this.erroContador.set(chaveErro, agora);
      }

      console.warn('Erro crítico detectado:', message);
    } else {
      // Erros não críticos seguem fluxo padrão
      this.toastr.erro(error);
    }

    console.error('Erro tratado globalmente:', error);
  }

  private isErroCritico(message: string): boolean {
    const padroesCriticos = [
      'Cannot read property',
      'undefined',
      'null',
      'of undefined',
      'reading',
      'is not a function'
    ];

    return padroesCriticos.some(p => message.includes(p));
  }

  private redirecionarParaPaginaDeErro(message: string): void {
    if (!this.router.url.includes('/pages/erro')) {
      this.router.navigate(['/pages/erro'], {
        state: { 
          message: 'Erro crítico detectado repetidamente: ' + message,
          currentUrl: this.router.url
        }
      });
      this.toastr.erro('Erro: ' + message);
    }
  }

  private extractMessage(error: any): string {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return error.message;
    if (error?.message) return error.message;
    return JSON.stringify(error);
  }
}